module.exports = __webpack_public_path__ + "img/logo-lanqimu-default.a20cac78.png";